export default __webpack_public_path__ + "static/media/menuIcon.8c6e2742.svg";